import { render, staticRenderFns } from "./search-results.vue?vue&type=template&id=095365b1&scoped=true&"
import script from "./search-results.vue?vue&type=script&lang=js&"
export * from "./search-results.vue?vue&type=script&lang=js&"
import style0 from "./search-results.vue?vue&type=style&index=0&id=095365b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095365b1",
  null
  
)

export default component.exports